import { GradeLevelEnum } from '@lon/shared/gql/types';
import { ColorKey, GradeLevelScoreConfig } from './types';

export const colors: Record<ColorKey, { bgColor: string; color: string }> = {
  red: {
    bgColor: 'danger.extraLight',
    color: 'danger.900',
  },
  yellow: {
    bgColor: 'yellow.extraLight',
    color: 'yellow.d',
  },
  blue: {
    bgColor: 'primary.30',
    color: 'primary.700',
  },
  green: {
    bgColor: 'olive.50',
    color: 'olive.900',
  },
};

export const gradeLevelScoreConfig: GradeLevelScoreConfig = {
  [GradeLevelEnum.GlK]: {
    red: { min: -400, max: -345, color: 'red' },
    yellow: { min: -340, max: -205, color: 'yellow' },
    blue: { min: -205, max: -20, color: 'blue' },
    green: { min: -15, max: 600, color: 'green' },
  },
  [GradeLevelEnum.Gl_1]: {
    red: { min: -400, max: -125, color: 'red' },
    yellow: { min: -120, max: 10, color: 'yellow' },
    blue: { min: 15, max: 185, color: 'blue' },
    green: { min: 190, max: 675, color: 'green' },
  },
  [GradeLevelEnum.Gl_2]: {
    red: { min: -400, max: 80, color: 'red' },
    yellow: { min: 85, max: 210, color: 'yellow' },
    blue: { min: 215, max: 375, color: 'blue' },
    green: { min: 380, max: 725, color: 'green' },
  },
  [GradeLevelEnum.Gl_3]: {
    red: { min: -400, max: 260, color: 'red' },
    yellow: { min: 265, max: 385, color: 'yellow' },
    blue: { min: 390, max: 545, color: 'blue' },
    green: { min: 550, max: 975, color: 'green' },
  },
  [GradeLevelEnum.Gl_4]: {
    red: { min: -400, max: 420, color: 'red' },
    yellow: { min: 425, max: 540, color: 'yellow' },
    blue: { min: 545, max: 695, color: 'blue' },
    green: { min: 700, max: 1075, color: 'green' },
  },
  [GradeLevelEnum.Gl_5]: {
    red: { min: -400, max: 550, color: 'red' },
    yellow: { min: 555, max: 675, color: 'yellow' },
    blue: { min: 680, max: 830, color: 'blue' },
    green: { min: 835, max: 1125, color: 'green' },
  },
  [GradeLevelEnum.Gl_6]: {
    red: { min: -400, max: 645, color: 'red' },
    yellow: { min: 650, max: 765, color: 'yellow' },
    blue: { min: 770, max: 920, color: 'blue' },
    green: { min: 925, max: 1200, color: 'green' },
  },
  [GradeLevelEnum.Gl_7]: {
    red: { min: -400, max: 740, color: 'red' },
    yellow: { min: 745, max: 865, color: 'yellow' },
    blue: { min: 870, max: 1020, color: 'blue' },
    green: { min: 1025, max: 1325, color: 'green' },
  },
  [GradeLevelEnum.Gl_8]: {
    red: { min: -400, max: 825, color: 'red' },
    yellow: { min: 830, max: 945, color: 'yellow' },
    blue: { min: 950, max: 1100, color: 'blue' },
    green: { min: 1105, max: 1450, color: 'green' },
  },
  [GradeLevelEnum.Gl_9]: {
    red: { min: -400, max: 895, color: 'red' },
    yellow: { min: 900, max: 1020, color: 'yellow' },
    blue: { min: 1025, max: 1175, color: 'blue' },
    green: { min: 1180, max: 1475, color: 'green' },
  },
  [GradeLevelEnum.Gl_10]: {
    red: { min: -400, max: 960, color: 'red' },
    yellow: { min: 965, max: 1080, color: 'yellow' },
    blue: { min: 1085, max: 1240, color: 'blue' },
    green: { min: 1245, max: 1500, color: 'green' },
  },
  [GradeLevelEnum.Gl_11]: {
    red: { min: -400, max: 1015, color: 'red' },
    yellow: { min: 1020, max: 1140, color: 'yellow' },
    blue: { min: 1145, max: 1295, color: 'blue' },
    green: { min: 1300, max: 1575, color: 'green' },
  },
  [GradeLevelEnum.Gl_12]: {
    red: { min: -400, max: 1015, color: 'red' },
    yellow: { min: 1020, max: 1140, color: 'yellow' },
    blue: { min: 1145, max: 1295, color: 'blue' },
    green: { min: 1300, max: 1650, color: 'green' },
  },
};
